export enum QDialogAction {
  confirm = 'confirm',
  cancel = 'cancel',
  close = 'close'
}
